import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import UndoIcon from "@mui/icons-material/Undo";
import { Box, Button } from "@mui/material";

import { brandRed, stone } from "../pricing-reports/design/designTokens";

const actionButtonSx = {
  flex: 1,
  minWidth: 0,
  borderRadius: 0,
  py: 1.25,
  fontWeight: 700,
  letterSpacing: "0.04em",
};

export default function VerifyPriceCardActions({ disabled, voided, onAccept, onReject, onRestore }) {
  if (voided) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "stretch",
          borderTop: `1px solid ${stone}`,
        }}
      >
        <Button
          startIcon={<UndoIcon />}
          disabled={disabled}
          onClick={(event) => {
            event.stopPropagation();
            onRestore();
          }}
          aria-label="Restore"
          sx={actionButtonSx}
        >
          Restore
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "stretch",
        borderTop: `1px solid ${stone}`,
      }}
    >
      <Button
        color="success"
        startIcon={<CheckIcon />}
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          onAccept();
        }}
        aria-label="Accept"
        sx={actionButtonSx}
      >
        Accept
      </Button>
      <Box sx={{ width: "1px", bgcolor: stone, flexShrink: 0 }} />
      <Button
        startIcon={<CloseIcon />}
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          onReject();
        }}
        aria-label="Reject"
        sx={{
          ...actionButtonSx,
          color: brandRed,
          "&:hover": {
            backgroundColor: "rgba(150, 11, 16, 0.06)",
          },
        }}
      >
        Reject
      </Button>
    </Box>
  );
}
